import { ref } from '@vue/composition-api'

const defaultState = () => ({
  paramsUrl: ref({}),
  urlMarket: ref(''),
})

export default defaultState
